import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserPlus, Mail, Lock, User, Phone, LogIn } from "lucide-react";
import PageTransition from "../components/PageTransition";
import { useCustomerAuth } from "../context/CustomerAuthContext";
import { toast } from "sonner";

const formatError = (e) => {
    const d = e?.response?.data?.detail;
    if (!d) return "Bir hata oluştu";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ") || "Doğrulama hatası";
    return String(d);
};

const Register = () => {
    const navigate = useNavigate();
    const { register } = useCustomerAuth();
    const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (form.password.length < 6) { toast.error("Şifre en az 6 karakter olmalı"); return; }
        if (form.phone && form.phone.replace(/\D/g, "").length < 10) { toast.error("Telefon numarası en az 10 rakam olmalı"); return; }
        setLoading(true);
        try {
            await register(form);
            toast.success("Üyeliğiniz oluşturuldu!");
            navigate("/profile");
        } catch (err) {
            toast.error(formatError(err));
        } finally { setLoading(false); }
    };

    return (
        <PageTransition>
            <div className="max-w-md mx-auto px-6 py-24">
                <div className="ornament-divider mb-6"><span className="font-arabic text-2xl text-gold">۞</span></div>
                <h1 className="font-serif text-4xl text-center mb-2">Üye Olun</h1>
                <p className="text-center text-muted_green text-sm mb-8">Rezervasyonlarınızı takip edin, yorum yazın, geçmiş konaklamalarınızı görün.</p>
                <form onSubmit={submit} className="space-y-4 border border-border_green bg-emerald_surface p-6" data-testid="register-form">
                    <div>
                        <label className="label-dark flex items-center gap-2"><User className="w-3.5 h-3.5 text-gold" /> Ad Soyad</label>
                        <input type="text" required minLength={2} className="input-dark" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name" />
                    </div>
                    <div>
                        <label className="label-dark flex items-center gap-2"><Mail className="w-3.5 h-3.5 text-gold" /> E-posta</label>
                        <input type="email" required className="input-dark" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email" />
                    </div>
                    <div>
                        <label className="label-dark flex items-center gap-2"><Phone className="w-3.5 h-3.5 text-gold" /> Telefon <span className="text-muted_green text-[10px] uppercase tracking-[0.15em]">(opsiyonel)</span></label>
                        <input type="tel" className="input-dark" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="+90 555 ... (isteğe bağlı)" data-testid="register-phone" />
                    </div>
                    <div>
                        <label className="label-dark flex items-center gap-2"><Lock className="w-3.5 h-3.5 text-gold" /> Şifre (en az 6 karakter)</label>
                        <input type="password" required minLength={6} className="input-dark" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password" />
                    </div>
                    <button type="submit" disabled={loading} className="btn-gold w-full" data-testid="register-submit">
                        <UserPlus className="w-4 h-4" /> {loading ? "Üyelik oluşturuluyor…" : "Üye Ol"}
                    </button>
                    <div className="text-center text-sm text-muted_green pt-2 border-t border-border_green">
                        Zaten hesabınız var mı? <Link to="/login" className="text-gold hover:underline font-semibold" data-testid="goto-login"><LogIn className="w-3.5 h-3.5 inline" /> Giriş Yapın</Link>
                    </div>
                </form>
            </div>
        </PageTransition>
    );
};

export default Register;
